<!--
 * @Author: zl
 * @Date: 2021-12-16 14:07:16
 * @LastEditTime: 2022-4-21 16:33:00
 * @LastEditors: 钱磊
 * @Description: 申诉企业审核
-->
<template>
	<el-dialog
		title="企业申诉"
		:visible.sync="dialogShow"
		center
		top="3vh"
		:close-on-click-modal="false"
		custom-class="shensu-dialog"
		width="1000px"
		@closed="closeAppeal"
		destroy-on-close
	>
		<div class="header-tip">
			当您的企业确认被他人注册，或者原企业主无法正常操作转让时，您可以使用申诉功能。建议您在申诉前可以通过在线咨询或拨打客服热线400-800-6335，向客服反馈您所遇到的问题，客服会协助您解决您的问题。
		</div>
		<el-form :model="appealForm" ref="appealForm" size="small">
			<el-row class="mt20">
				<el-col :span="12" :offset="5">
					<el-form-item label="要申诉的企业名称：" label-width="180px">
						{{ appealForm.sname }}
					</el-form-item>
				</el-col>
				<el-col :span="12" :offset="5">
					<el-form-item label="统一社会信用代码：" label-width="180px">
						{{ appealForm.creditCode }}
					</el-form-item>
				</el-col>
				<el-col :span="12" :offset="5">
					<el-form-item label="申诉类型：" label-width="180px">
						我要找回我的企业
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="mt20">
				<el-col :span="24" class="upload-box">
					<el-carousel :autoplay="false" :loop="false" class="w100" height="200px">
						<el-carousel-item class="carousel-item-style">
							<div class="upload-item">
								<public-upload
									ref="shensuInfo_1"
									isViewMode
									:viewFilesList="chioseFile('shensuInfo_1')"
									listType="picture-card"
								></public-upload>
								<div class="top-item-text yyzz text-left">
									企业证件(营业执照/个体工商/事业单位...)
								</div>
							</div>
							<div class="upload-item">
								<public-upload
									ref="shensuInfo_2"
									isViewMode
									:viewFilesList="chioseFile('shensuInfo_2')"
									listType="picture-card"
								></public-upload>
								<div class="top-item-text yyzz">申诉人身份证（国徽面）</div>
							</div>
							<div class="upload-item">
								<public-upload
									ref="shensuInfo_3"
									isViewMode
									:viewFilesList="chioseFile('shensuInfo_3')"
									listType="picture-card"
								></public-upload>
								<div class="top-item-text yyzz">申诉人身份证（人像面）</div>
							</div>
							<div class="upload-item">
								<public-upload
									ref="shensuInfo_4"
									isViewMode
									:viewFilesList="chioseFile('shensuInfo_4')"
									listType="picture-card"
								></public-upload>
								<div class="top-item-text yyzz">企业申诉书（盖章）</div>
							</div>
						</el-carousel-item>
					</el-carousel>
				</el-col>
			</el-row>
			<el-row class="mt20">
				<el-col :span="24">
					<el-form-item label="单位类型：">
						{{ appealForm.flatTypeName }}
					</el-form-item>
				</el-col>
				<el-col :span="11">
					<el-form-item label="法人代表姓名：">
						{{ appealForm.legal }}
					</el-form-item>
				</el-col>
				<el-col :span="12" :offset="1">
					<el-form-item label="法人代表手机号：">
						{{ appealForm.legalPhone }}
					</el-form-item>
				</el-col>
				<el-col :span="11">
					<el-form-item label="申诉人姓名：">
						{{ appealForm.agent }}
					</el-form-item>
				</el-col>
				<el-col :span="12" :offset="1">
					<el-form-item label="申诉人证件号：">
						{{ appealForm.agentNo }}
					</el-form-item>
				</el-col>
				<el-col :span="11">
					<el-form-item label="申诉人手机号：">
						{{ appealForm.agentPhone }}
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="10" class="sp-form-item mt10">
				<el-form-item
					label="审核结果："
					label-width="92px"
					:rules="[{ required: true, message: '不能为空...', trigger: 'blur' }]"
					prop="status"
					v-if="!isDisabled"
				>
					<el-select v-model="appealForm.status" placeholder="请选择...">
						<el-option label="审核通过" :value="1"></el-option>
						<el-option label="驳回" :value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-else>
					审核结果：
					<span :class="{ green: rowData.status == 1, red: rowData.status == 2 }">
						{{ rowData.status === 1 ? '认证通过' : '认证失败' }}
					</span>
				</el-form-item>
				<el-form-item
					label="审核意见："
					label-width="92px"
					:rules="[{ required: true, message: '不能为空...', trigger: 'blur' }]"
					prop="remark"
					v-if="!isDisabled"
				>
					<el-input
						type="textarea"
						v-model="appealForm.remark"
						placeholder="请输入..."
						show-word-limit
						maxlength="200"
						:autosize="{ minRows: 4 }"
					></el-input>
				</el-form-item>
				<el-form-item v-else> 审核意见：{{ rowData.remark }} </el-form-item>
			</el-row>
		</el-form>
		<div slot="footer" v-if="mode != 'view'">
			<el-button class="btn" @click="dialogShow = false">取 消</el-button>
			<el-button type="primary" class="btn btn-blue" :loading="btnLoading" @click="doSubmit">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import * as API from 'api/modules/audit'
import { auditSubmit } from 'api/modules/invoice'
export default {
	props: {
		rowData: {
			type: Object,
			default: () => {
				return {}
			}
		},
		mode: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			dialogShow: false,
			appealForm: {
				creType: 3, //申诉类型
				flatType: '', //单位类型
				flatTypeName: '', //单位类型
				sname: '', //要申诉的企业名称
				creditCode: '', //社会统一信用码
				legal: '', //法人代表
				legalPhone: '', //法人代表手机号
				agent: '', //申诉人姓名
				agentNo: '', //申诉人身份证号
				agentPhone: '', //申诉人手机号
				verifyCode: '', //验证码`
				userId: '', //申诉人id
				remark: '', //审核意见
				status: '' //审核状态
			},
			auditForm: {},
			btnLoading: false,
			viewFilesList: [] //附件图片列表
		}
	},
	created() {
		// 获取申诉企业信息
		this.getCompanyInfo()
		// console.log(this.rowData);
	},
	methods: {
		// 获取申诉企业信息
		getCompanyInfo() {
			API.getRecordDetail({
				recordId: this.rowData.id,
				id: this.rowData.id
			})
				.then((res) => {
					this.viewFilesList = res.data.files
					Object.keys(this.appealForm).map((x) => {
						Object.keys(res.data).map((y) => {
							if (x == y) {
								this.appealForm[x] = res.data[y]
							}
						})
					})
				})
				.then((res) => {
					let obj = this.projectDict.dwlx.find((x) => x.value == this.appealForm.flatType)
					this.appealForm.flatTypeName = obj.sname
				})
		},

		// 提交审核
		doSubmit() {
			this.$refs.appealForm.validate((valid) => {
				if (valid) {
					this.btnLoading = true
					auditSubmit({
						id: this.rowData.id,
						busId: this.rowData.busId,
						status: this.appealForm.status,
						remark: this.appealForm.remark,
						busType: this.rowData.busType
					})
						.then((res) => {
							this.$message.success('操作完成')
							this.$emit('closeAppeal', false)
						})
						.catch(() => {
							this.btnLoading = false
						})
					return
				}
				this.$message.error('请完善表单！')
			})
		},

		// 判断图片类型
		chioseFile(Type) {
			let data = {}
			switch (Type) {
				case 'shensuInfo_1':
					data = this.viewFilesList.filter((x) => x.assortment == 'shensuInfo_1')
					break
				case 'shensuInfo_2':
					data = this.viewFilesList.filter((x) => x.assortment == 'shensuInfo_2')
					break
				case 'shensuInfo_3':
					data = this.viewFilesList.filter((x) => x.assortment == 'shensuInfo_3')
					break
				case 'shensuInfo_4':
					data = this.viewFilesList.filter((x) => x.assortment == 'shensuInfo_4')
					break
			}
			return data
		},

		// 关闭时触发
		closeAppeal() {
			this.$emit('closeAppeal', false)
		}
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict
		}),
		...mapState('user', {
			userInfo: (state) => state.userInfo
		}),
		isDisabled() {
			return this.mode == 'view'
		}
	}
}
</script>
<style lang="less" scoped>
.red {
	color: red;
}
.green {
	color: green;
}
.header-tip {
	padding: 0 50px;
	font-size: 14px;
	text-indent: 2rem;
}
.upload-box {
	display: flex;
}
.upload-item {
	width: 220px;
	height: 150px;
	/deep/ .upload-text {
		vertical-align: middle !important;
	}
	/deep/.el-upload-list__item {
		width: 210px !important;
		height: 150px !important;
	}
	/deep/.el-upload {
		width: 210px !important;
		height: 150px !important;
	}
	/deep/ .img-size {
		width: 210px !important;
		height: 150px !important;
	}
	/deep/ .el-upload__tip {
		display: none;
	}
	.top-item-text {
		font-size: 12px;
		line-height: 30px;
		color: #666;
		text-align: center;
	}

	.yyzz {
		line-height: 18px;
		margin-top: 5px;
		&::before {
			content: '*';
			color: #f56c6c;
			margin-right: 4px;
		}
	}
	.text-left {
		text-align: left !important;
	}
}
.upload-item + .upload-item {
	margin-left: 15px;
}
.carousel-item-style {
	display: flex;
	justify-content: space-between;
}
.el-form-item {
	margin-bottom: 4px !important;
}
.sp-form-item {
	.el-form-item {
		margin-bottom: 15px !important;
	}
}
</style>
